import { BoardGame } from '../game'
import { Holder } from '@typinghare/holder'

/**
 * Board game holder.
 */
export const boardGameHolder = Holder.of<BoardGame>()